export interface SeasonDivisionPool {
	uuid: string;
}

export interface SeasonDivisionPoolData extends SeasonDivisionPool {
	captainPermissions: CaptainLineupsAndScoresPermissions;
	captainCanEditLineupAfterSelection: boolean;
	opponentLineupVisibility: OpponentLineupVisibility;
	publicLineupVisibility: PublicLineupVisibility;
	lineupEntryOrder: LineupEntryOrder;
}

export enum LineupEntryOrder {
	UNDEFINED_LINEUP_ENTRY = 'UNDEFINED_LINEUP_ENTRY',
	HOME_TEAM_FIRST_LINEUP_ENTRY = 'HOME_TEAM_FIRST_LINEUP_ENTRY',
	AWAY_TEAM_FIRST_LINEUP_ENTRY = 'AWAY_TEAM_FIRST_LINEUP_ENTRY',
	EITHER_TEAM_FIRST_LINEUP_ENTRY = 'EITHER_TEAM_FIRST_LINEUP_ENTRY'
}

export enum CaptainLineupsAndScoresPermissions {
	NO_LINEUP_NO_SCORES_CAPTAIN_PERMISSION = 'NO_LINEUP_NO_SCORES_CAPTAIN_PERMISSION',
	FULL_CONTROL_CAPTAIN_PERMISSION = 'FULL_CONTROL_CAPTAIN_PERMISSION',
	LINEUP_ONLY_CAPTAIN_PERMISSION = 'LINEUP_ONLY_CAPTAIN_PERMISSION',
	SCORES_ONLY_CAPTAIN_PERMISSION = 'SCORES_ONLY_CAPTAIN_PERMISSION'
}

export enum OpponentLineupVisibility {
	ALWAYS_SHOW_OPPONENT_LINEUP = 'ALWAYS_SHOW_OPPONENT_LINEUP',
	HIDE_UNTIL_BOTH_SELECTED_OPPONENT_LINEUP = 'HIDE_UNTIL_BOTH_SELECTED_OPPONENT_LINEUP',
	SHOW_WHEN_LINEUPS_ARE_PUBLISHED = 'SHOW_WHEN_LINEUPS_ARE_PUBLISHED'
}

export enum PublicLineupVisibility {
	UNDEFINED_PUBLIC_LINEUP_VISIBILITY = 'UNDEFINED_PUBLIC_LINEUP_VISIBILITY',
	NOT_UNTIL_GAME_DAY_PUBLIC_LINEUP_VISIBILITY = 'NOT_UNTIL_GAME_DAY_PUBLIC_LINEUP_VISIBILITY',
	FIRST_DAY_OF_SCHEDULED_EVENT_PUBLIC_LINEUP_VISIBILITY = 'FIRST_DAY_OF_SCHEDULED_EVENT_PUBLIC_LINEUP_VISIBILITY',
	AS_SOON_AS_CREATED_PUBLIC_LINEUP_VISIBILITY = 'AS_SOON_AS_CREATED_PUBLIC_LINEUP_VISIBILITY',
	ONE_DAY_PRIOR_GAME_DAY_PUBLIC_LINEUP_VISIBILITY = 'ONE_DAY_PRIOR_GAME_DAY_PUBLIC_LINEUP_VISIBILITY',
	TWO_DAYS_PRIOR_GAME_DAY_PUBLIC_LINEUP_VISIBILITY = 'TWO_DAYS_PRIOR_GAME_DAY_PUBLIC_LINEUP_VISIBILITY',
	THREE_DAYS_PRIOR_GAME_DAY_PUBLIC_LINEUP_VISIBILITY = 'THREE_DAYS_PRIOR_GAME_DAY_PUBLIC_LINEUP_VISIBILITY',
	SHOW_BASED_ON_MATCHUP_PUBLIC_LINEUP_VISIBILITY = 'SHOW_BASED_ON_MATCHUP_PUBLIC_LINEUP_VISIBILITY'
}
